import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "nb_cookie_consent";

// Événement global permettant de rouvrir le bandeau depuis "Gestion des cookies"
export const openCookieSettings = () => {
  window.dispatchEvent(new Event("nb-open-cookies"));
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("nb-open-cookies", reopen);
    return () => window.removeEventListener("nb-open-cookies", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-[90] rounded-xl border border-[#c9a24b]/25 bg-[#4a2026]/95 backdrop-blur-md shadow-[0_18px_44px_-24px_rgba(30,20,16,0.7)] p-5"
    >
      <p className="text-sm leading-relaxed text-[#f0e6cf]">
        Nous utilisons uniquement des cookies nécessaires au bon fonctionnement
        du site. Vous pouvez accepter ou refuser les cookies non essentiels.
      </p>
      <p className="mt-2 text-xs text-[#d8c3a0]">
        En savoir plus :{" "}
        <Link
          to="/politique-confidentialite"
          className="underline hover:text-[#f0e6cf] transition-colors"
        >
          politique de confidentialité
        </Link>
        .
      </p>
      <div className="mt-4 flex items-center gap-3">
        <button
          type="button"
          data-testid="cookie-refuse"
          onClick={() => choose("refused")}
          className="flex-1 rounded-full border border-[#f0e6cf]/45 text-[#f0e6cf] py-2.5 text-sm hover:bg-[#f0e6cf]/10 transition-colors"
        >
          Refuser
        </button>
        <button
          type="button"
          data-testid="cookie-accept"
          onClick={() => choose("accepted")}
          className="flex-1 rounded-full bg-[#f0e6cf] text-[#4a2026] py-2.5 text-sm font-medium hover:bg-white transition-colors"
        >
          Accepter
        </button>
      </div>
    </div>
  );
};
